import { LocationTimeZoneDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useLocationTimezone = (locationId?: number) => {
  const { loading, data } = useQuery(LocationTimeZoneDocument, {
    variables: { id: Number(locationId) },
    skip: !locationId,
  })

  return {
    loading,
    timezone: data?.locations.location?.timezone,
  }
}
